import { toSafeDate } from './safeDate';

// Display stored line amounts only; never reconstruct historical financial values.
export function importeRenglonCompra(detalle) {
  const raw = detalle?.subtotal ?? detalle?.precio_total;
  if (raw == null || (typeof raw !== 'number' && typeof raw !== 'string') ||
      String(raw).trim() === '') return 'Importe no disponible';
  const value = Number(raw);
  return Number.isFinite(value) ? '$' + value.toFixed(2) : 'Importe no disponible';
}

export function referenciaCompra(compra) {
  const numero = compra?.numero;
  if (numero != null && String(numero).trim()) return String(numero).trim();
  const id = compra?.id;
  return id != null && String(id).trim() ? String(id).trim() : 'Sin referencia';
}

export function formatCompraFecha(value, options) {
  const date = toSafeDate(value);
  return date ? date.toLocaleString('es-ES', options) : 'Fecha no disponible';
}
